import { Observable } from 'rxjs';
import { AuctionAsset } from '../../models/auction-asset';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';


export class AuctionAssetApi extends ApiBase {
  model = 'auction-asset';

  public create(auctionAsset: AuctionAsset): Observable<AuctionAsset> {
    return this.http.post<AuctionAsset>(
      this.buildUrl(),
      auctionAsset,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public deleteById(id: string): Observable<void> {
    return this.http.delete<void>(
      this.buildUrl(id),
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public patchOrCreate(auctionAsset: AuctionAsset): Observable<AuctionAsset> {
    return this.http.patch<AuctionAsset>(
      this.buildUrl(),
      auctionAsset,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

}
